<div class="flex flex-col h-full bg-white overflow-hidden">
  <app-order-list-header [activeFilter]="activeFilter()" [counts]="filterCounts()"
    [totalCollectedFormatted]="totalCollected() | formatPrice" [searchQuery]="searchQuery()"
    (filterChange)="setFilter($event)" (searchChange)="onSearchChange($event)" />

  <!-- Contenu principal -->
  <main class="flex-1 p-5 overflow-hidden">
    <div class="bg-gris-4 rounded-[10px] h-full flex flex-col overflow-hidden border border-gris-3">
      <h2 class="text-[20px] font-semibold fg-noir-2 px-5 pt-5 pb-[15px] shrink-0 leading-none">
        {{ 'order_list.table_title' | translate }}
      </h2>

      <!-- En-tête du tableau -->
      <div class="flex items-center px-[15px] py-[15px] bg-white mx-5 rounded-t-[5px] shrink-0">
        <!-- Nom -->
        <div class="flex items-center gap-[10px] min-w-[147px] flex-1 shrink-0">
          <div class="size-[10px] rounded-full bg-noir-2 shrink-0"></div>
          <span class="text-[16px] font-semibold fg-noir-2">
            {{ 'order_list.col.name' | translate }}
          </span>
        </div>

        <!-- Matricule -->
        <span class="text-[16px] font-semibold fg-noir-2 min-w-[89px] flex-1 text-center shrink-0">
          {{ 'order_list.col.matricule' | translate }}
        </span>

        <!-- Heure -->
        <span class="text-[16px] font-semibold fg-noir-2 min-w-[55px] flex-1 text-center shrink-0">
          {{ 'order_list.col.time' | translate }}
        </span>

        <!-- Type de commande -->
        <span class="text-[16px] font-semibold fg-noir-2 min-w-[130px] flex-1 text-center shrink-0">
          {{ 'order_list.col.meal_moment' | translate }}
        </span>

        <!-- Mode de paiement -->
        <span class="text-[16px] font-semibold fg-noir-2 min-w-[124px] flex-1 text-center shrink-0">
          {{ 'order_list.col.payment_mode' | translate }}
        </span>

        <!-- Montant -->
        <span class="text-[16px] font-semibold fg-noir-2 min-w-[70px] flex-1 text-center shrink-0">
          {{ 'order_list.col.amount' | translate }}
        </span>

        <!-- Statut -->
        <span class="text-[16px] font-semibold fg-noir-2 min-w-[126px] max-w-[150px] flex-1 text-center shrink-0">
          {{ 'order_list.col.status' | translate }}
        </span>

        <!-- Actions -->
        <div class="min-w-[126px] flex-1 text-center shrink-0">
          {{ 'order_list.col.action' | translate }}
        </div>
      </div>

      <!-- Lignes du tableau -->
      <div class="flex-1 overflow-y-auto mx-5">
        @if (isLoading()) {
        <div class="flex items-center justify-center py-[40px] bg-white">
          <app-loader size="w-8 h-8" />
        </div>
        } @else {
        @for (item of orders(); track item.id) {
        <div class="flex items-center px-[15px] py-[10px] bg-white border-t border-gris-3 w-full">
          <!-- Nom avec indicateur -->
          <div class="flex items-center gap-[10px] min-w-[147px] flex-1 shrink-0 truncate">
            <div class="size-[10px] rounded-full shrink-0" [class]="getStatusClass(item.order.status)"></div>
            <span class="text-[16px] font-medium fg-gris-1 truncate">
              {{ item.user.firstname + ' ' + item.user.lastname }}
            </span>
          </div>

          <!-- Matricule -->
          <span class="text-[16px] font-medium fg-gris-1 min-w-[89px] flex-1 text-center shrink-0">
            #{{ item.user.badge_number ?? '—' }}
          </span>

          <!-- Heure -->
          <span class="text-[16px] font-medium fg-gris-1 min-w-[55px] flex-1 text-center shrink-0">
            {{ item.order.created_at | date: 'HH:mm' }}
          </span>

          <!-- Type de commande -->
          <span class="text-[16px] font-medium fg-gris-1 min-w-[130px] flex-1 text-center shrink-0">
            {{ item.order.mealmoment.name }}
          </span>

          <!-- Mode de paiement -->
          <span class="text-[16px] font-medium fg-gris-1 min-w-[124px] flex-1 text-center shrink-0">
            {{ getPaymentMode(item.order.payments) }}
          </span>

          <!-- Montant -->
          <span class="text-[19px] font-bold fg-vert-1 min-w-[70px] flex-1 text-center shrink-0">
            {{ item.order.price | formatPrice }}
          </span>

          <!-- Statut -->
          <div class="min-w-[126px] max-w-[150px] flex-1 text-center shrink-0">
            <span
              class="inline-flex items-center justify-center px-[20px] h-[41px] rounded-[30px] text-[16px] font-semibold text-white w-full"
              [class]="getStatusClass(item.order.status)">
              {{ 'order_list.status.' + item.order.status | translate }}
            </span>
          </div>

          <!-- Actions -->
          <div class="min-w-[126px] flex-1 flex gap-[10px] justify-center shrink-0">
            <button type="button" (click)="goToOrderDetail(item.id)"
              class="border border-gris-3 rounded-[5px] size-[58px] flex items-center justify-center cursor-pointer hover:bg-gris-4 transition-colors shrink-0 bg-white">
              <app-svg class="fg-gris-1" height="22" svgPath="assets/svg/eye.svg" width="22" />
            </button>
            <button type="button" (click)="cancelOrder(item.id)" [disabled]="item.order.status === 'cancelled'"
              class="border border-gris-3 rounded-[5px] size-[58px] flex items-center justify-center cursor-pointer hover:bg-gris-4 transition-colors shrink-0 bg-white disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white">
              <app-svg class="fg-gris-1" height="22" svgPath="assets/svg/trash.svg" width="22" />
            </button>
          </div>
        </div>
        }

        @if (orders().length === 0) {
        <div class="flex items-center justify-center py-[40px] bg-white">
          <span class="text-[16px] fg-gris-1">
            {{ 'order_list.empty' | translate }}
          </span>
        </div>
        }
        }
      </div>

      <div class="mx-5 mb-5 shrink-0">
        @if (pagination(); as currentPagination) {
        <app-pagination [pagination]="currentPagination" [disabled]="isLoading()" (pageChange)="loadPage($event)" />
        }
      </div>
    </div>
  </main>
</div>

@if (cancelReasonModalOpen()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
  <app-modal-force-reason class="w-[500px]" [title]="'modal.cancel_order.title' | translate"
    [subtitle]="'modal.cancel_order.subtitle' | translate" [reasonLabel]="'modal.cancel_order.reason_label' | translate"
    [reasonPlaceholder]="'modal.cancel_order.reason_placeholder' | translate"
    [requiredErrorMessage]="'modal.cancel_order.required_error' | translate" [cancelLabel]="'common.cancel' | translate"
    [confirmLabel]="'common.confirm' | translate" (cancelClick)="onCancelReasonModalClose()"
    (confirmClick)="onConfirmCancelReason($event)" />
</div>
}